var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail24X24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.855 10.7h-8.186v3.068h4.906c-.188 1.307-1.445 3.84-4.905 3.84-3.02 0-5.469-2.517-5.469-5.623 0-3.105 2.449-5.623 5.468-5.623a4.864 4.864 0 0 1 3.461 1.374l2.356-2.34a8.3 8.3 0 0 0-5.817-2.31C6.882 3.086 3 7.077 3 12s3.882 8.914 8.67 8.914c5.007 0 8.33-3.625 8.33-8.736a8.003 8.003 0 0 0-.123-1.485l-.022.007Z",
    fill: "#0B0204"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail24X24);
export default __webpack_public_path__ + "static/media/gmail-24x24.7e885d62866bf14e242e44e46719a67d.svg";
export { ForwardRef as ReactComponent };